import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
@Component({
    selector: 'app-dialogo-guardar-seguro',
    templateUrl: './dialogo-guardar-seguro.component.html',
    styleUrls: ['./dialogo-guardar-seguro.component.css'],
    standalone: true,
    imports: [FormsModule,CommonModule,NbCardModule,NbIconModule,DropdownModule,MatCardModule,MatFormFieldModule,MatInputModule,AngularSlickgridModule,NbTabsetModule],
})
export class DialogoGuardarSeguroComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<DialogoGuardarSeguroComponent>) { }

  ngOnInit(): void {
  }

  guardarSeguros(estado:boolean){
    this.dialogRef.close(estado);
  }
}
